import * as types from './GroupActionTypes';
import {initialstate} from './initialstate';

const reducer = (state = initialstate, action) => {
	switch (action.type) {
		case types.UPDATE_DOMAIN_NAME: {
			const newState = {...state};
			const found = newState.domains.some((el) => el.id === action.payload.id);
			if (!found) {
				newState.domains.push(action.payload);
				return {...newState};
			}
			let objIndex = newState.domains.findIndex((obj) => obj.id == action.payload.id);
			newState.domains[objIndex].domainName = action.payload.domainName;
			return {...newState};
		}
		case types.SET_DOMAIN_EMPTY: {
			const newEmptyDomainState = {...state};
			let domainToEmpty = newEmptyDomainState.domains.findIndex((el) => el.id === action.payload.id);
			if (domainToEmpty >= 0) {
				newEmptyDomainState.domains[domainToEmpty].isEmpty = action.payload.isEmpty;
			}
			return {...newEmptyDomainState};
		}
		case types.REMOVE_DOMAIN_NAME: {
			const domains = state.domains.filter((el) => el.id !== action.payload.id);
			return {...state, domains};
		}
		case types.UPDATE_USERS: {
			const {id, firstName, lastName, emailAddress, userId, roles, isEmpty, isInternal} = action.payload;
			const existingUser = state.users.some((el) => el.id === id);
			if (!existingUser) {
				const newUser = {id, firstName, lastName, emailAddress, roles, userId, isEmpty, isInternal};
				return {...state, users: [...state.users, newUser]};
			}

			const updatedUser = {id, firstName, lastName, emailAddress, userId, isEmpty};
			const filteredUsers = _.filter(state.users, ({id}) => id === userId);

			return {...state, users: [...filteredUsers, updatedUser]};
		}
		case types.REMOVE_USER: {
			const users = state.users.filter((el) => el.id !== action.payload.id);
			return {...state, users};
		}
		case types.CLEAR_USER: {
			debugger;
			const newEmptyUserState1 = {...state};

			newEmptyUserState1.users = [];
			return newEmptyUserState1;
		}
		case types.SET_USER_EMPTY: {
			const {id, isEmpty} = action.payload;
			const userToEmpty = _.find(state.users, ({id}) => id === id);

			if (userToEmpty) {
				const updatedUser = {...userToEmpty, isEmpty};
				const filteredUsers = _.filter(state.users, ({id}) => id === id);
				return {...state, users: [...filteredUsers, updatedUser]};
			}
			return state;
		}
		case types.UPDATE_VIEWS: {
			const views = [...action.payload];
			return {...state, views};
		}
		case types.SET_DUPLICATE_VALIDATION: {
			let isDuplicate = action.payload.isDuplicate;
			return {...state, isDuplicate};
		}
		case types.SET_DOMAIN_DUPLICATE: {
			const {id: domainId, isDuplicate} = action.payload;
			const domain = _.find(state.domains, ({id}) => id === domainId);

			if (domain) {
				const updatedDomain = {...domain, isDuplicate};
				const filteredDomains = _.filter(state.domains, ({id}) => id !== domainId);
				return {...state, domains: [...filteredDomains, updatedDomain]};
			}

			return state;
		}
		case types.CLEAR_STATE: {
			return {
				views: [],
				users: [],
				domains: []
			};
		}
		case types.SET_GROUP_STATE: {
			return action.payload;
		}
		case types.SET_VALID_INVALID_DOMAIN_DATA: {
			const {id: domainId, isValidDomainData: isValidDomain} = action.attributes;
			const domain = _.find(state.domains, ({id}) => id === domainId);

			if (domain) {
				const updatedDomain = {...domain, isValidDomain};
				const filteredDomains = _.filter(state.domains, ({id}) => id !== domainId);
				return {...state, domains: [...filteredDomains, updatedDomain]};
			}

			return state;
		}
		default: {
			return state;
		}
	}
};

export default reducer;
